export default "__VITE_ASSET__B9JBy$F1__"